const colors = {
  brand: {
    lightGray: "#efefef",
    gray: "#333333",
    red: "#bf0008",
  },
};

export default colors;
